import { LeaderBoardDetails } from './../../../api-models/requests/leaderboard/LeaderBoardDetailsModel';
import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';

@Injectable({
  providedIn: 'root',
})
export class GetLeaderBoardDetailService {
  constructor(private baseClient: BaseHttpClientService) {}

  call(leaderbord_id) {
    return this.baseClient.get<LeaderBoardDetails>(
      `/api/v1/LeaderBoard/get_leaderboard_detail/${leaderbord_id}`
    );
  }
}
